import React, { FunctionComponent } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import LaunchIcon from '@mui/icons-material/Launch';

import {
  Box,
  Grid
} from '@mui/material';

import {
  Button,
  Typography
} from './styled';

type Props = {
  zmClientInfo: {
    id?: string|number;
    birth_date?: string;
    gender?: string;
    man_name?: string;
    man_name_pre?: string;
    girl_name?: string;
    girl_name_pre?: string;
    voorletters?: string;
    first_name?: string;
    bsn?: string;
    street?: string;
    number?: string;
    zip?: string;
    city?: string;
    province?: string;
    country?: string;
    valid_practice?: boolean;
  };
};

const { DateTime } = require("luxon");

export const AttachmentClientZorgmail: FunctionComponent<Props> = ({zmClientInfo}) => {
  const theme = useTheme();
  const {t, i18n} = useTranslation(['translations']);

  return (<Box sx={{
    // cursor: 'pointer',
    padding: 1,
    border: '1px solid transprent',
    borderColor: theme.palette.primary.main,
    display: 'inline-block',
    borderRadius: 5,
    marginRight: 1,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.02)'
    }
  }} onClick={(e) => {
    e.preventDefault();
    // if (!!zmClientInfo.id) window.open(`/user/${zmClientInfo.id}/detail`);
  }}>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="caption">{t("shared.zorgmail.linked_client.show.name")}</Typography>
        <Typography>{[zmClientInfo.voorletters, zmClientInfo.first_name, (zmClientInfo.gender === "V" ? zmClientInfo.girl_name_pre : zmClientInfo.man_name_pre), (zmClientInfo.gender === "V" ? zmClientInfo.girl_name : zmClientInfo.man_name)].filter(fff => !!fff).join(" ")}</Typography>
      </Grid>
      {zmClientInfo.gender === "V" && !!zmClientInfo.man_name && <Grid item xs={12}>
        <Typography variant="caption">{t("shared.zorgmail.linked_client.show.man_name")}</Typography>
        <Typography>{[zmClientInfo.man_name_pre, zmClientInfo.man_name].filter(fff => !!fff).join(" ")}</Typography>
      </Grid>}
      <Grid item xs={12}>
        <Typography variant="caption">{t("shared.zorgmail.linked_client.show.details")}</Typography>
        <Typography>
          {!!zmClientInfo?.birth_date && DateTime.fromFormat(zmClientInfo?.birth_date, "y-LL-dd").toFormat("dd/LL/y")}
          {!zmClientInfo?.birth_date && t("shared.zorgmail.linked_client.show.no_birthdate")}
          <FiberManualRecordIcon
            sx={{
              fontSize: '0.3rem',
              margin: '0 8px',
              color: 'rgba(0, 0, 0, 0.2)',
              verticalAlign: 'middle'
            }}
          />
          {zmClientInfo?.gender}
        </Typography>
      </Grid>
      {!!zmClientInfo?.bsn && <Grid item xs={12}>
        <Typography variant="caption">{t("shared.zorgmail.linked_client.show.bsn")}</Typography>
        <Typography>{zmClientInfo?.bsn}</Typography>
      </Grid>}
      {<Grid item xs={12}>
        <Typography variant="caption">{t("shared.zorgmail.linked_client.show.address")}</Typography>
        <Typography>{zmClientInfo?.street} {zmClientInfo?.number}, {zmClientInfo?.zip} {zmClientInfo?.city}</Typography>
        {(!!zmClientInfo?.province || !!zmClientInfo?.country) && <Typography>{!!zmClientInfo?.province && zmClientInfo?.province} {!!zmClientInfo?.country && zmClientInfo?.country}</Typography>}
      </Grid>}
      {!!zmClientInfo?.id && !!zmClientInfo.valid_practice && <Grid item xs={12}>
        <Button
          label={t("coach.general.actions.goto")}
          id='go_to_user'
          contained
          startIcon={<LaunchIcon />}
          onClick={(v) => {
            window.open(`/user/${zmClientInfo.id}/detail`);
          }}
          sx={{marginTop: 2}}
        />
      </Grid>}
      {!!zmClientInfo?.id && !zmClientInfo.valid_practice && <Grid item xs={12}>
        <Typography sx={{color: theme.palette.secondary.main, fontSize: '0.8rem'}}>{t("shared.ehealth_mail.linked_client_not_in_practice", "Client niet in uw praktijk")}</Typography>
      </Grid>}
    </Grid>
  </Box>);
}
